import Vue from 'vue'


/**
 * 千分位格式化
 * @param {Number} val
 */
Vue.filter('toThousands',(val) => {
    let num = (val || 0).toString(),
        result = '';
    while (num.length > 3) {
        result = ',' + num.slice(-3) + result;
        num = num.slice(0, num.length - 3);
    }
    if (num) {
        result = num + result;
    }
    return result;
});



Vue.filter('returnFloat',(val) => {
    let value = Math.round(parseFloat(val) * 100) / 100;
    let xsd = value.toString().split(".");
    if (xsd.length == 1) {
        value = value.toString() + ".00";
        return value;
    }
    if (xsd.length > 1) {
        if (xsd[1].length < 2) {
            value = value.toString() + "0";
        }
        return value;
    }
});